// extracted by mini-css-extract-plugin
export default {"products":"pu-z","card":"qu-z","oosMessaging":"ru-z"};